import { db } from "@react-native-firebase/database";
import { get, ref } from "firebase/database";
import { useEffect, useRef, useState } from "react";
import { BsEyeFill, BsPenFill } from "react-icons/bs";
import { Dimensions, Text, TouchableOpacity } from "react-native";
import { MOBILE_VIEW_WIDTH } from "res/constants";
import Loader from "src/components/Loader";
import { AddReviewAssignmentForm } from "./AddReviewAssignment";
import Menu from "./Menu";
import styles from "./styles/ReviewAssignmentScreen";
import navhelper from "core/navhelper";
const ReviewAssignmentScreen = () => {
  const [isVisible, setIsVisible] = useState(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const screenWidth = Dimensions.get("window").width;
  const [showLoader, setShowLoader] = useState(false);
const [reviewsList,setReviewsList]=useState([])
const [editableReview,setEditableReview]=useState(null)
  const handleFormSubmit=()=>
    {
        setIsVisible(false)
        setEditMode(false)
        fetchReviews()
    }

  const fetchReviews = async () => {
    try {
      const dbRef = ref(db, `reviewAssignment`);
      await get(dbRef).then((snapshot) => {
        if (snapshot.exists()) {
          const reviewFetchedData = snapshot.val();
          const reviewsArray = Object.keys(reviewFetchedData).map((key) => ({
            id: key,
            ...reviewFetchedData[key],
          }));
          console.log(reviewsArray);
          setReviewsList(reviewsArray)
        }
        setShowLoader(false)
      });
    } catch {
      console.log("ERROR");
      setShowLoader(false)
    }
  };

const [editMode,setEditMode]=useState(false)
  useEffect(() => {
    setShowLoader(true)
    fetchReviews();
  }, []);


  return (
    <div style={styles.outer}>
      <Menu />
      <div
        ref={scrollContainerRef}
        style={{...styles.inner,
          width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "90%",
        }}
      >
        <div
          style={{
            width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "97%",
          }}
        >
          <div
            style={{...styles.review,
              textAlign: screenWidth<MOBILE_VIEW_WIDTH?"center":"left",
              marginTop: screenWidth > MOBILE_VIEW_WIDTH ? 20 : 10,
            }}
          >
            Review Assignment
          </div>

        {
          (isVisible)&&<AddReviewAssignmentForm editMode={editMode} editableReview={editableReview} openForm={true} handleFormClose={()=>setIsVisible(!isVisible)} handleFormSubmit={handleFormSubmit}/>
        }
         <TouchableOpacity style={styles.addButton} 
         onPress={()=>{
            setEditMode(false)
            setIsVisible(true)}}>
            <Text style={styles.addCandidateButtonText}>Add New</Text>
          </TouchableOpacity>
          <div
            style={styles.assignedText}
          >
          </div>
          <div style={styles.assigned}>
            <table style={styles.table}  >
              <thead>
                <tr style={styles.tableHeadRow}>
                  <th style={styles.tableHead}>
                    Reviewer Name
                  </th>
                  <th style={styles.tableHead}>
                    User to be Reviewed
                  </th>
                  <th style={styles.tableHead}>
                    Role
                  </th>
                  <th style={styles.tableHead}>
                    Status
                  </th>
                  <th style={styles.tableHead}>
                    Start Date
                  </th>
                  <th style={styles.tableHead}>
                    Due Date
                  </th>
                  <th style={styles.tableHead}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
              {reviewsList.map((review, index) => (
                <>{review.status!=='Saved'&&
                    <tr key={review.id} style={{ backgroundColor: index % 2 === 1 ? "#2F48581A" : undefined }}>
                    <td style={styles.startBorder}>{review.ReviewerUserName}</td>     
                    <td style={styles.tableCell}>{review.ReviewedUserName}</td>
                    <td style={styles.tableCell}>{review.ReviewerRole}</td>
                    <td style={styles.tableCell}>{review.status}</td>
                    <td style={styles.tableCell}>{review.startDate||''}</td>
                    <td style={styles.tableCell}>{review.dueDate||''}</td>
                    <td style={styles.tableEndCell}>
                              <div style={styles.endBar}>
                             {review.status==='In-Process'? <BsPenFill  
                                style={{cursor:'pointer'}}
                                onClick={()=>{
                               setEditableReview(review)
                           setEditMode(true)       
                          setIsVisible(true)
                                }}
                              /> 
                                 :   <BsEyeFill
                                style={{cursor:'pointer'}}
                                onClick={()=>{
                                  navhelper.push('ReviewSubmissionScreen',{review:review,mode:'View'})
                                }}
                              /> }
                              </div>
                              </td>
                        </tr>}
                        </>
))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {showLoader && <Loader />}
    </div>
  );
};



export default ReviewAssignmentScreen;
